import styled from 'styled-components';

export const SpinnerContainer = styled.div`
  width: auto;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  svg {
    width: 64px;
    height: 54px;
    animation: Spin 1s infinite linear;
  }
  @keyframes Spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
